module.exports = __webpack_public_path__ + "static/media/404-overflow.246bfb44.svg";